import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://www.echt.gold';

const AGB = () => {
  return (
    <>
      <Helmet>
        <title>AGB - Allgemeine Geschäftsbedingungen | Echt Gold</title>
        <meta name="description" content="Allgemeine Geschäftsbedingungen von Echt Gold - Uhren-, Schmuck- und Gold- und Silberankauf in NRW." />
        <link rel="canonical" href={`${BASE_URL}/agb`} />
      </Helmet>

      <div className="bg-black/90 py-8 border-b border-gold/20">
        <div className="container mx-auto px-4">
          <div className="text-sm text-gray-400 mb-2">
            <Link to="/" className="hover:text-gold">Home</Link> / <span className="text-gold">AGB</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold gold-text">Allgemeine Geschäftsbedingungen</h1>
        </div>
      </div>

      <section className="section section-dark">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <div className="card space-y-6 text-gray-300">
              <div>
                <h2 className="text-2xl font-bold mb-4 gold-text">1. Geltungsbereich</h2>
                <p>
                  Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Ankaufsgeschäfte zwischen Echt Gold (nachfolgend „Ankaufer“) und dem Verkäufer (nachfolgend „Verkäufer“).
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4 gold-text">2. Vertragsabschluss</h2>
                <p className="mb-2">
                  Der Vertrag kommt erst mit Annahme des Kaufangebots durch den Verkäufer zustande. Das Kaufangebot des Ankäufers ist unverbindlich und kann bis zur Annahme durch den Verkäufer widerrufen werden.
                </p>
                <p>
                  Bei Ablehnung des Angebots durch den Verkäufer werden die eingesandten Gegenstände kostenlos und versichert zurückgesandt.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4 gold-text">3. Preisermittlung</h2>
                <p>
                  Die Preisermittlung erfolgt nach:
                </p>
                <ul className="list-disc ml-6 mt-2 space-y-1">
                  <li>dem aktuellen Tageskurs der jeweiligen Edelmetalle</li>
                  <li>dem ermittelten Feingehalt und Gewicht</li>
                  <li>dem Zustand und der Marktgängigkeit der Gegenstände</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4 gold-text">4. Legitimationsprüfung</h2>
                <p>
                  Gemäß § 3 Geldwäschegesetz ist der Ankäufer verpflichtet, bei jedem Ankauf die Identität des Verkäufers mittels gültigem Personalausweis oder Reisepass festzustellen und zu dokumentieren.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4 gold-text">5. Eigentum und Haftung</h2>
                <p className="mb-2">
                  Der Verkäufer versichert, dass er rechtmäßiger Eigentümer der zum Ankauf angebotenen Gegenstände ist und diese frei von Rechten Dritter sind.
                </p>
                <p>
                  Während des Transports mit unserem versicherten Versandlabel sind die Gegenstände bis zu einem Wert von 25.000 Euro vollumfänglich versichert.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4 gold-text">6. Zahlung</h2>
                <p>
                  Die Auszahlung erfolgt nach Vertragsabschluss:
                </p>
                <ul className="list-disc ml-6 mt-2 space-y-1">
                  <li>bei persönlichem Termin: sofort bar oder per Überweisung</li>
                  <li>beim Versandankauf: per Überweisung innerhalb von 24 Stunden nach Annahme des Angebots</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4 gold-text">7. Rücktritt</h2>
                <p>
                  Der Verkäufer kann das Angebot ablehnen. In diesem Fall werden die eingesandten Gegenstände kostenlos und versichert zurückgeschickt. Nach Annahme des Angebots und erfolgter Auszahlung ist ein Rücktritt ausgeschlossen.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4 gold-text">8. Schlussbestimmungen</h2>
                <p className="mb-2">
                  Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.
                </p>
                <p>
                  Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen hiervon unberührt.
                </p>
              </div>

              <p className="text-sm text-gray-400 mt-8">
                Stand: November 2024
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AGB;